const updateListener = (willShow, showed, listenerType, eventHandler) => {
  if (willShow && !showed) {
    document.addEventListener(listenerType, eventHandler);
  } else if (!willShow && showed) {
    document.removeEventListener(listenerType, eventHandler);
  }
}

export default updateListener;
